<template>
  <div>
    <div v-if="loading" style="height:calc(100vh)"></div>
    <div class="note-wrap" v-if="!loading">
      <div class="note-left">
        <div class="note-item">
          <div class="note-title-wrap">
            <div class="note-title">パーソナルデータ</div>
            <div class="flex-space"></div>
            <el-button size="mini" @click="toImport()">
              <font-awesome-icon :icon="['far', 'file-import']" style="margin-right: 3px;" />
              インポート</el-button
            >
          </div>
          <div class="info-wrap">
            <div class="info-item" v-for="info in notes_info" :key="info.property_id">
              <div class="info-property">
                <div class="info-check" :class="info.info_content ? 'input' : ''">
                  <font-awesome-icon :icon="['fal', 'check']" style="color:#fff; font-size:8px" v-if="info.info_content" />
                </div>
                {{ info.property }}
              </div>
              <div class="info-value personal">
                <div
                  :class="[info.info_content == null || info.info_content == '' ? 'info-content nocomment' : 'info-content']"
                  @click="activeInfo(info.info_content, info.property_id)"
                  v-if="info_show != info.property_id"
                >
                  <div class="info-value-content" v-if="permission.personal_data.access">{{ info.info_content == null || info.info_content == "" ? "入力" : info.info_content }}</div>
                  <div class="info-value-content" style="padding: 4px 0px" v-else><font-awesome-icon :icon="['fas', 'lock']" /></div>
                </div>
                <div style="display:flex; align-items:center" v-if="info_show == info.property_id">
                  <el-input
                    size="mini"
                    v-model="info.info_content"
                    :id="'info' + info.property_id"
                    @change="comment_on ? '' : changeInfo(info.info_content, info.property, info.property_id, info.property_name)"
                    @blur="comment_on ? '' : changeInfo(info.info_content, info.property, info.property_id, info.property_name)"
                    @keypress.enter.native="comment_on ? '' : changeInfo(info.info_content, info.property, info.property_id, info.property_name)"
                    :type="'input'"
                    style="width:170px;"
                  ></el-input>
                </div>
              </div>
            </div>
            <!-- <div class="info-setting"><font-awesome-icon :icon="['fas', 'cog']" style="margin-right: 3px;" /> 設定</div> -->
          </div>
        </div>
        <NoteCustomizeTag :sns_type="sns_type" :id="id" :tags="tags" @addTag="addTag" @updateTag="updateTag" />
      </div>
      <div class="note-right">
        <div class="note-item">
          <div class="note-title-wrap">
            <div class="note-title">ノート</div>
            <div class="flex-space"></div>
            <el-button size="mini" @click="toImport()">
              <font-awesome-icon :icon="['far', 'file-import']" style="margin-right: 3px;" />
              インポート</el-button
            >
            <el-button type="success" size="mini" icon="el-icon-plus" @click="addNote()">ノートを追加</el-button>
          </div>
          <div v-if="notes.length == 0" class="note-nonote">インフルエンサーの情報を追加できます。</div>
          <div class="list-group-item" v-for="note in notes" :key="note.name" @mouseover="mouseover = note.note_id" @mouseleave="mouseover = -1">
            <div class="list-group-note">
              <noteComment :note="note" :id="id" :sns_type="sns_type" :note_show.sync="note_show" @openNote="openNote" @clearNote="clearNote" />
            </div>
            <div class="flex-space"></div>
            <div class="note-date-area">
              <div class="flex-space"></div>
              <span v-if="mouseover == note.note_id" class="note-delete">
                <font-awesome-icon :icon="['far', 'trash-alt']" @click="deleteNote(note.note_id)" />
              </span>
              {{ note.update_at }}
            </div>
          </div>
        </div>
        <div class="note-item" style="margin-top:30px">
          <div class="note-title-wrap">
            <div class="note-title">追加されているリスト</div>
            <div class="flex-space"></div>
            <div style="font-size:11px; color:#666" v-if="mylist.length > 0">{{ mylist.length }}件のリスト</div>
          </div>
          <div v-if="mylist.length == 0" class="note-nonote">リストに追加されていません。</div>
          <div class="note-list-group" v-else>
            <div class="note-list-item" v-for="(list, list_index) in mylist" :key="list.list_id" :class="list_index + 1 == mylist.length ? 'noborder' : ''" v-show="list.list_name">
              <div class="note-list" v-if="list.list_name">
                <div class="note-list-circle">
                  <font-awesome-icon :icon="['fal', 'list']" style="color:#fff; font-size:8px" />
                </div>
                <el-tooltip :disabled="list.list_name.length < 13" placement="top-start">
                  <div slot="content">{{ list.list_name }}</div>
                  <div class="note-list-name pointer" @click="openList(list.list_id)">{{ list.list_name }}</div>
                </el-tooltip>
              </div>
              <div class="info-value list">
                <div class="note-list-content">
                  <status style="width:100px" :list_id="list.list_id" :sns_type="sns_type" :id="id" :status="list.status" :index="list_index" @syncStatus="syncStatus" />
                  <comment :type="'comment'" :client_comment.sync="list.comment" :id="id" :list_id="list.list_id" :sns_type="sns_type" :index="list_index" @syncComment="syncComment" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const root = process.env.VUE_APP_API;
const loadPropertyAPI = root + "/api/note/load_property";
const loadNoteAPI = root + "/api/note/load_note";
const createInfoAPI = root + "/api/note/create_info";
const deleteNoteAPI = root + "/api/note/delete_note";

import noteComment from "./note_comment";
import comment from "../list/comment";
import status from "../list/status";
import NoteCustomizeTag from "./note_customize_tag.vue";

export default {
  name: "note",
  props: ["id", "sns_type"],
  components: {
    noteComment,
    comment,
    status,
    NoteCustomizeTag,
  },
  data() {
    return {
      notes: [],
      notes_info: [],
      properties: [],
      mylist: [],
      tags: [],
      mouseover: -1,
      comment_on: false,
      target: -1,
      loading: true,
      info_show: -1,
      note_show: -1,
      info_before: "",
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    permission() {
      return this.$store.state.permission;
    },
  },
  mounted() {
    this.loadNote(true);
    this.loadProperty();
  },
  methods: {
    addNote() {
      if (this.permission.note.edit) {
        var d = new Date();
        var date = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate() + " " + d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
        var new_note = { note_id: "new", content: "", update_at: date };
        this.notes.unshift(new_note);
        this.note_show = "new";
        setTimeout(() => {
          document.getElementById("note" + this.note_show).focus();
        }, 100);
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    clearNote() {
      this.notes.shift();
    },
    openNote(val) {
      this.note_show = val;
    },
    loadNote(loading) {
      if (loading == true) this.loading = true;
      this.axios
        .get(loadNoteAPI, {
          params: {
            token: this.token,
            user_token: this.user_token,
            influencer: this.id,
            sns_type: this.sns_type,
          },
        })
        .then((response) => {
          this.notes = response.data.notes;
          this.notes_info = response.data.notes_info;
          this.mylist = response.data.mylist;
          this.tags = response.data.tags;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    loadProperty() {
      this.axios
        .get(loadPropertyAPI, {
          params: {
            token: this.token,
          },
        })
        .then((response) => {
          this.properties = response.data.properties;
        })
        .catch(() => {});
    },
    deleteNote(note_id) {
      if (this.permission.note.edit) {
        this.$confirm("ノートを削除してもよろしいですか?<br>※この操作は取り消せません", "ノートの削除", {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "削除",
          confirmButtonClass: "danger",
          cancelButtonText: "キャンセル",
          type: "warning",
        }).then(() => {
          var params = new URLSearchParams();
          params.append("token", this.token);
          params.append("note_id", note_id);
          this.axios
            .post(deleteNoteAPI, params)
            .then((response) => {
              if (response.data.status == "OK") {
                this.loadNote(false);
                this.$message({
                  type: "success",
                  offset: 7,
                  showClose: true,
                  message: "ノートを削除しました",
                });
              } else {
                this.$message({
                  type: "error",
                  offset: 7,
                  showClose: true,
                  message: "ノートを削除できませんでした",
                });
              }
            })
            .catch(() => {});
        });
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    activeInfo(info_content, id) {
      if (this.permission.personal_data.edit) {
        this.info_show = id;
        this.info_before = info_content;
        setTimeout(() => {
          document.getElementById("info" + id).focus();
        }, 50);
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    changeInfo(info_content, property, property_id, property_name) {
      this.comment_on = true;
      this.info_show = -1;
      if (info_content != this.info_before) {
        var params = new URLSearchParams();
        params.append("token", this.token);
        params.append("sns_type", this.sns_type);
        params.append("influencer", this.id);
        params.append("property_id", property_id);
        params.append("info_content", info_content);
        this.axios
          .post(createInfoAPI, params)
          .then(() => {
            this.$message({
              type: "success",
              offset: 7,
              showClose: true,
              message: property + "を更新しました",
            });
            this.$emit("noteReactive", info_content, property_name);
          })
          .catch(() => {});
      }
      setTimeout(() => {
        this.comment_on = false;
      }, 300);
    },
    openList(list_id) {
      let routeData = this.$router.resolve({
        name: "listDetail",
        params: {
          list_id: list_id,
        },
      });
      window.open(routeData.href, "_blank");
    },
    addTag(tag) {
      this.tags.push(tag);
    },
    toImport() {
      this.$router.push({ name: "request", params: { import_drawer: true } });
    },
    syncComment(index, value, type, list_id) {
      this.mylist[index].comment = value;
      this.$emit("commentReactive", value, list_id);
    },
    syncStatus(index, value, list_id) {
      this.mylist[index].status = value;
      this.$emit("statusReactive", value, list_id);
    },
    updateTag(type, tag_index, new_tag) {
      if (new_tag !== "" && type === "add") {
          this.tags.push(new_tag);
      } else if (new_tag === "" && type === "delete"){
        this.tags.splice(tag_index, 1);
      }

      this.$emit("tagReactive", type, tag_index, new_tag);
    },
  },
  watch: {
    id() {
      this.notes = [];
      this.notes_info = [];
      this.loadNote();
    },
  },
};
</script>
